import { F0Alert } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { WorkAreaMapLocationNode } from 'modules/space_control/hooks/useWorkAreaMap'

interface PinAlertProps {
  workSpace: WorkAreaMapLocationNode
  onDelete: () => void
}

export const PinAlert: React.FC<PinAlertProps> = ({ workSpace, onDelete }) => (
  <F0Alert
    title={workSpace.workSpace?.name ?? ''}
    description={i18n.t('space_control.map.space_mapped')}
    variant="info"
    action={{
      label: i18n.t('space_control.map.remove_from_map'),
      onClick: onDelete,
    }}
  />
)
